module.exports = __webpack_public_path__ + "static/media/6_slogan_of-op-locatie.8d5abbcc.png";